import { Component, OnInit, OnDestroy, ChangeDetectorRef, ElementRef, Renderer2, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { Subscription } from 'rxjs';

import { CalendarOptions, FullCalendarComponent } from '@fullcalendar/angular';
import { ComponentType } from '@angular/cdk/portal';
import momentTimezonePlugin from '@fullcalendar/moment-timezone';
import momentPlugin from '@fullcalendar/moment';
import timeGridPlugin from '@fullcalendar/timegrid';
import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';

import { BaseComponent } from '../../forms/base-form/base-form.component';
import { DrupalRESTService } from 'src/app/services/drupal-rest.service';
import { StudioConfigService } from 'src/app/services/studio-config.service';
import { RefreshService } from 'src/app/services/refresh.service';
import { DialogService } from 'src/app/services/dialog.service';
import { EntityRESTService } from 'src/app/services/entity-rest.service';
import { UtilityService } from 'src/app/services/utility.service';
import { FieldsService } from 'src/app/services/fields.service';
import { TaxonomyService } from 'src/app/services/taxonomy.service';
import { AuthRESTService } from 'src/app/services/auth-rest.service';
import { AuthService } from 'src/app/services/auth.service';
import { MenuRESTService } from 'src/app/services/menu-rest.service';
import { RouteEventsService } from 'src/app/route-events.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { ConfigPagesService } from 'src/app/services/config-pages.service';
import { PackagesService } from 'src/app/services/packages.service';
import { UserService } from 'src/app/services/user.service';
import { ComponentRefreshService } from 'src/app/services/component-refresh.service';
import { TranslateService } from '@ngx-translate/core';
import { StorageService } from 'src/app/services/storage.service';
import { WeekCalculationService } from 'src/app/services/week-calculation.service';
import { EventColorService } from 'src/app/services/event-color.service';
import { EventLessonEntityComponent } from '../../forms/event-lesson-entity/event-lesson-entity.component';
import { EventGroupLessonEntityComponent } from '../../forms/event-group-lesson-entity/event-group-lesson-entity.component';
import { EventServicesEntityComponent } from '../../forms/event-services-entity/event-services-entity.component';
import { EventSchedulesEntityComponent } from '../../forms/event-schedules-entity/event-schedules-entity.component';
import { StudentInquiryEntityComponent } from '../../forms/student-inquiry-entity/student-inquiry-entity.component';
import { BookingMenuChoice } from '../../shared/booking-menu/booking-menu.component';
import { UpdateLessonComponent } from '../../forms/update-lesson/update-lesson.component';
import { UpdateGroupLessonComponent } from '../../forms/update-group-lesson/update-group-lesson.component';
import { UpdateServiceComponent } from '../../forms/update-service/update-service.component';
import { AppointmentDetailsComponent } from '../../forms/appointment-details/appointment-details.component';
import { PrintAttendanceComponent } from '../print-attendance/print-attendance.component';

import moment from 'moment';
import { buildOfficeBusinessHours } from 'src/app/constants/calendar.constants';
import 'moment-timezone';
import tippy, { roundArrow } from 'tippy.js';
import { hideAll } from 'tippy.js';
import { data } from 'jquery';
import { GroupLessonComponent } from '../../forms/group-lesson/group-lesson.component';
import { InquiryComponent } from '../../forms/inquiry/inquiry.component';
import { LessonComponent } from '../../forms/lesson/lesson.component';
import { PaymentsEntityComponent } from '../../forms/payments-entity/payments-entity.component';
import { SchedulesComponent } from '../../forms/schedules/schedules.component';
import { ServicesComponent } from '../../forms/services/services.component';
import { StudentAccountComponent } from '../../forms/student-account/student-account.component';
import { LoggerService } from '../../../services/logger.service';

type DayViewEvent = {
  id: string;
  start: string;
  end: string;
  appointmentType?: string;
  status?: string;
  color?: string;
  resourceId?: string;
  extendedProps?: Record<string, any>;
};

@Component({
  selector: 'app-day-view-mobile',
  templateUrl: './day-view-mobile.component.html',
  styleUrls: ['./day-view-mobile.component.css']
})
export class DayViewMobileComponent extends BaseComponent implements OnInit, OnDestroy {

  @ViewChild('instructorInfo') instructorInfo;
  @ViewChild('calendar') override calendarComponent: FullCalendarComponent;
  @ViewChild('customPopover') customPopover: ElementRef;
  @ViewChild('instructorToggleComponent', { read: ElementRef }) instructorToggleRef: ElementRef;

  // Add properties for studio information
  studioTimezone: string = '';
  studioCountry: string = '';
  studioName: string = '';
  studioTimezoneLoaded: boolean = false;

  LessonComponent = LessonComponent;
  GroupLessonComponent = GroupLessonComponent;
  SchedulesComponent = SchedulesComponent;
  ServicesComponent = ServicesComponent;
  StudentAccountComponent = StudentAccountComponent;
  InquiryComponent = InquiryComponent;
  EventLessonEntityComponent = EventLessonEntityComponent
  PaymentsEntityComponent = PaymentsEntityComponent
  EventScheduleEntityComponent = EventSchedulesEntityComponent;
  StudentInquiryEntityComponent = StudentInquiryEntityComponent;
  EventGroupLessonEntityComponent = EventGroupLessonEntityComponent;
  EventServicesEntityComponent = EventServicesEntityComponent;
  UpdateLessonComponent = UpdateLessonComponent;
  UpdateGroupLessonComponent = UpdateGroupLessonComponent;
  UpdateServiceComponent = UpdateServiceComponent;

  copyData = {};
  AMTDayView: any = "";
  AMTConfiguration: any = "";
  InstructorList: {} = "";
  AMTCalendarConfiguration: any = "";

  Events: any;
  Resources = {};

  // Filter configuration
  filterInstructorCategory: string[] = [];
  filterLessonType: any;
  filterStudent: string = "";
  filterDate: Date | string = new Date();
  filterGroupLesson: boolean = false;
  filterLesson: boolean = false;
  filterServices: boolean = false;
  filterHiddenEvents: boolean = false;

  // Resources array for instructor toggle component
  resourcesArray: { id: string, title: string }[] = [];
  instructors: { id: string, title: string }[] = [];
  selectedInstructorId: string = '';
  get instructorToggleStorageScope(): string | null {
    const studio = this._authService.selectedStudio;
    if (studio?.id) {
      return `studio-${studio.id}`;
    }
    return studio?.key || studio?.name || null;
  }
  isInstructorDrawerOpen: boolean = false;
  currentInstructorName: string = 'Loading...';
  currentDate: Date = new Date();

  // Store all available resources for filtering
  private allResources: any[] = [];
  private currentlyVisibleResources: Set<string> = new Set();

  // FullCalendar
  currentSelectedInstructorID;
  currentSelectedDuration;
  currentSelectedStartTime;

  summaryCount = {
    privateLessonDaily: 0,
    privateLessonWeekly: 0,
    privateTakenLessonDaily: 0,
    privateTakenLessonWeekly: 0,
  }

  private applyCurrentStudioName(): void {
    const studio = this._authService.selectedStudio;
    if (studio) {
      this.studioName = studio.name || studio.key || this.studioName;
    }
  }

  private subscribeToStudioChanges(): void {
    this.studioChangeSubscription = this._authService.selectedStudioChanged.subscribe(studio => {
      if (studio) {
        LoggerService.log('[STUDIO] Studio changed, reloading session configuration');
        this.studioName = studio.name || studio.key || this.studioName;

        // Clear only the session time cache
        this.clearSessionTimeCache();

        // Clear the studio timezone so we know it needs to be reloaded
        this.studioTimezone = '';
        this.studioCountry = '';
        this.studioTimezoneLoaded = false;

        // Force reload studio timezone
        this.loadStudioTimeZoneInfo();

        // Force refresh session configuration
        this.getAMTSessionTime(true);

        // Refresh the calendar to get new studio's data
        setTimeout(() => {
          this.refreshCalendar();
        }, 100);
      }
    });
  }

  newDateStart: string;
  newDateEnd: string;
  AMTSessionTime: Object;

  tippyHideDuration = 100;
  tippyInstructorHoverInstances = new Map();
  tippyEventHoverInstances = new Map();
  weekNumber: string;

  intervalId = setInterval(() => {
    this.refreshCalendar();
  }, 60000);
  noTippy: boolean = false;

  // Timer interval for studio time display
  timerIntervalId: any;

  // Flag to prevent refreshing during drag operations
  isDragging: boolean = false;



  // Custom hover tooltip
  private nextEventsCache = new Map<string, any>();
  // Map to track in-flight API requests
  private pendingRequests = new Map<string, Promise<any>>();
  // Subscription for studio changes
  private studioChangeSubscription: Subscription;
  // Studio config is app-lifetime; released on destroy and replaced (not stacked)
  // on each studio switch.
  private studioConfigSubscription: Subscription;

  constructor(
    public override _refreshService: RefreshService,
    public override _dialogService: DialogService,
    public override _entityRESTService: EntityRESTService,
    public override _utilityService: UtilityService,
    public override _fieldsService: FieldsService,
    public override _drupalRESTService: DrupalRESTService,
    public override _taxonomyService: TaxonomyService,
    public override _router: Router,
    public override _activatedRoute: ActivatedRoute,
    public override _authRESTService: AuthRESTService,
    public override _authService: AuthService,
    public override _menuRESTService: MenuRESTService,
    public override _formBuilder: FormBuilder,
    public override _routeEventsService: RouteEventsService,
    public override _permissionsService: PermissionsService,
    public override _renderer2: Renderer2,
    public override _configPages: ConfigPagesService,
    public override _packagesService: PackagesService,
    public override _snackBar: MatSnackBar,
    public override _userRESTService: UserService,
    public override _el: ElementRef,
    public override _changeDetectorRef: ChangeDetectorRef,
    public override _sanitizer: DomSanitizer,
    public override _studioConfigService: StudioConfigService,
    public override _componentRefreshService: ComponentRefreshService,
    public override _translateService: TranslateService,
    private _storageService: StorageService,
    private weekCalculationService: WeekCalculationService,
    private _eventColorService: EventColorService
  ) {
    super(
      _refreshService,
      _dialogService,
      _entityRESTService,
      _utilityService,
      _fieldsService,
      _drupalRESTService,
      _taxonomyService,
      _router,
      _activatedRoute,
      _authRESTService,
      _authService,
      _menuRESTService,
      _formBuilder,
      _routeEventsService,
      _permissionsService,
      _renderer2,
      _configPages,
      _packagesService,
      _snackBar,
      _userRESTService,
      _el,
      _changeDetectorRef,
      _sanitizer,
      _studioConfigService,
      _componentRefreshService,
      _translateService
    );
  }

  selectInstructor(instructorId: string): void {
    this.selectedInstructorId = instructorId;
    this.persistSelectedInstructor();
    this.updateCurrentInstructorName();
    this.refreshCalendar();
    this.getAMTSessionTime(true);
  }

  private persistSelectedInstructor(): void {
    this._storageService.setItem('dayViewMobile.selectedInstructor', this.selectedInstructorId || '');
  }

  private loadPersistedInstructor(): void {
    if (this.selectedInstructorId) {
      return;
    }
    const stored = this._storageService.getItem('dayViewMobile.selectedInstructor');
    if (stored) {
      this.selectedInstructorId = stored;
    }
  }

  private updateCurrentInstructorName(): void {
    if (!this.selectedInstructorId && this.instructors.length) {
      this.selectedInstructorId = this.instructors[0].id;
    }
    const current = this.instructors.find(instr => instr.id === this.selectedInstructorId);
    this.currentInstructorName = current?.title || 'Select Instructor';
  }

  handleMobileInstructorSelection(instructorId: string): void {
    if (!instructorId || instructorId === this.selectedInstructorId) {
      return;
    }
    this.selectInstructor(instructorId);
  }

  addLesson(): void {
    this.openEntityComponent(EventLessonEntityComponent, 'events', 'lessons', 'create');
  }

  addGroupLesson(): void {
    this.openEntityComponent(EventGroupLessonEntityComponent, 'events', 'group_lesson', 'create');
  }

  addService(): void {
    this.openEntityComponent(EventServicesEntityComponent, 'events', 'services', 'create');
  }

  addSchedule(): void {
    this.openEntityComponent(EventSchedulesEntityComponent, 'events', 'schedules', 'create');
  }

  addInquiry(): void {
    this.openEntityComponent(StudentInquiryEntityComponent, 'student_accounts', 'student_account', 'create', '', {
      'dayview_field_date_and_time': this.calendarDateInquiry,
      'inquiry': true
    });
  }

  addInquiryFromSlot(): void {
    this.openEntityComponent(StudentInquiryEntityComponent, 'student_accounts', 'student_account', 'create', '', {
      'dayview_field_date_and_time': this.currentSelectedStartTime || this.calendarDateInquiry,
      'field_teacher': this.currentSelectedInstructorID,
      'inquiry': true
    });
  }

  updateLesson(): void {
    this.openDialog(UpdateLessonComponent, 'statusFormWithData', { eventData: this.Events });
  }

  updateGroupLesson(): void {
    this.openDialog(UpdateGroupLessonComponent, 'statusFormWithData', { eventData: this.Events });
  }

  updateService(): void {
    this.openDialog(UpdateServiceComponent, 'statusFormWithData', { eventData: this.Events });
  }

  openFilters(): void {
    this._routeEventsService.previousRoutePath.next('openDayViewFilters');
  }

  openPrintDialog(): void {
    LoggerService.log('Print dialog not implemented in mobile yet');
  }

  private applyResourceFiltering(selectedInstructors: string[] = []): void {
    // Simplified mobile implementation: rely on server-side filtering
  }

  private mountInstructorToggleInHeader(): void {
    // Mobile view does not mount instructor toggle in header
  }

  private cleanupEventTooltips(): void {
    this.tippyEventHoverInstances.forEach(instance => instance?.destroy());
    this.tippyEventHoverInstances.clear();
  }

  private refreshCalendarWithDatePreservation(): void {
    this.refreshCalendar();
    this.getAMTSessionTime();
  }

  private loadStudioTimeZoneInfo(): void {
    LoggerService.log('[TIMEZONE] Loading studio timezone info...');
    LoggerService.log('[TIMEZONE] Browser timezone:', Intl.DateTimeFormat().resolvedOptions().timeZone);
    LoggerService.log('[TIMEZONE] Current moment default timezone:', moment.tz.guess());

    this.studioConfigSubscription?.unsubscribe();
    this.studioConfigSubscription = this._studioConfigService.getStudioConfig().subscribe(
      (config) => {
        if (config) {
          this.studioTimezone = config?.['field_studio_timezone']?.[0]?.value || 'America/New_York';
          this.studioCountry = config?.['field_studio_address']?.[0]?.country_code || 'US';

          LoggerService.log('[TIMEZONE] Studio timezone loaded:', this.studioTimezone);
          LoggerService.log('[TIMEZONE] Studio country:', this.studioCountry);
          LoggerService.log('[TIMEZONE] Current time in browser:', moment().format('YYYY-MM-DD HH:mm:ss Z'));
          LoggerService.log('[TIMEZONE] Current time in studio TZ:', moment.tz(this.studioTimezone).format('YYYY-MM-DD HH:mm:ss Z'));

          // CRITICAL: Set timezone in options BEFORE marking as loaded so the calendar's
          // first render (gated by *ngIf="studioTimezoneLoaded") uses the studio zone.
          this.calendarOptions.timeZone = this.studioTimezone;

          // If the calendar already rendered (e.g. studio change), update the live API too.
          if (this.calendarComponent && this.calendarComponent.getApi()) {
            LoggerService.log('[TIMEZONE] Updating calendar API timezone to:', this.studioTimezone);
            this.calendarComponent.getApi().setOption('timeZone', this.studioTimezone);
            // Force the now indicator to refresh with the new timezone
            this.calendarComponent.getApi().setOption('nowIndicator', false);
            this.calendarComponent.getApi().setOption('nowIndicator', true);
            this.refreshCalendar();
          }

          this.studioTimezoneLoaded = true;
        }
      },
      (error) => {
        LoggerService.error('Error loading studio timezone:', error);
        this.studioTimezone = 'America/New_York'; // Default fallback
        this.studioCountry = 'US';

        this.calendarOptions.timeZone = this.studioTimezone;

        if (this.calendarComponent && this.calendarComponent.getApi()) {
          this.calendarComponent.getApi().setOption('timeZone', this.studioTimezone);
          this.calendarComponent.getApi().setOption('nowIndicator', false);
          this.calendarComponent.getApi().setOption('nowIndicator', true);
          this.refreshCalendar();
        }

        this.studioTimezoneLoaded = true;
      }
    );
  }

  private createNextEventsCacheKey(eventId: string, dateStr: string): string {
    return `next-events-${eventId}-${moment(dateStr).format('YYYY-MM-DD')}`;
  }

  private formatNextEventsHtml(nextEvents: any): string {
    if (!nextEvents || !nextEvents.upcomingEventList?.length) {
      return '<div class="next-events-container"><p>No upcoming events</p></div>';
    }
    const items = nextEvents.upcomingEventList
      .map((event: any) => `<li class="next-event-item">${event}</li>`)
      .join('');
    return `<div class="next-events-container"><ul class="next-events-list">${items}</ul></div>`;
  }

  private loadNextEvents(
    eventId: string,
    date: string,
    studentId: string | null,
    onSuccess: (data: any) => void,
    onError: (error: any) => void
  ): void {
    onSuccess({ upcomingEventList: [] });
  }

  ngOnInit(): void {
    this.loadPersistedInstructor();
    this.getAMTCalendarConfiguration();
    this.getAMTSessionTime();
    this.loadStudioTimeZoneInfo();

    this.applyCurrentStudioName();
    this.subscribeToStudioChanges();
  }

  ngOnDestroy(): void {
    // Close all dialogs, otherwise dialogs will stay open when navigating.
    this._dialogService.closeAll();

    // Clean up all tooltip instances to prevent memory leaks
    this.cleanupEventTooltips();

    this.detachPopoverDismissListener();

    // Unsubscribe from studio changes
    if (this.studioChangeSubscription) {
      this.studioChangeSubscription.unsubscribe();
    }
    this.studioConfigSubscription?.unsubscribe();

    // Clean up instructor tooltip instances
    this.tippyInstructorHoverInstances.forEach((instance, resourceId) => {
      try {
        if (instance && typeof instance.destroy === 'function') {
          instance.destroy();
        }
      } catch (error) {
        LoggerService.error(`[TOOLTIP] Error destroying instructor tooltip instance for resource ${resourceId}:`, error);
      }
    });
    this.tippyInstructorHoverInstances.clear();

    clearInterval(this.intervalId);
    if (this.timerIntervalId) {
      clearInterval(this.timerIntervalId);
    }
  }

  openEntityComponent(component: ComponentType<unknown>, eckType: any, bundle: any, action: any, EntityID?: any, fieldsData?: {}) {
    // LoggerService.log('fieldsData')
    // LoggerService.log(fieldsData)
    this._dialogService.openDialog(component, "defaultWithData", {
      data: {
        EntityID: EntityID,
        eckType: eckType,
        bundle: bundle,
        action: action,
        fieldsData: fieldsData ?? '',
      },
    }).afterClosed().subscribe(data => {
      this.refreshCalendar();
    });
  }

  public dialogAddLessonData(configOptions) {
    configOptions['data'] = {
      instructors: this.filterInstructorCategory,
      lesson_types: this.filterLessonType
    };
    return configOptions;
  }

  /**
   * Utility to open dialogs with a default configuration.
   *
   * @param formName
   * @param dialogConfig
   */
  public openDialog(formName: ComponentType<unknown>, configName?, data?) {
    this._dialogService.openDialog(formName, configName, data)
      .afterClosed()
      .subscribe(result => {
        // Skip refresh if the dialog already triggered one (e.g., after delete)
        if (result?.refreshed) {
          return;
        }
        // wait 1 second and refresh the calendar.
        setTimeout(() => {
          this.refreshCalendar();
        }, 1000);
      });
  }

  /**
   * FullCalendar Configuration.
   */
  calendarOptions: CalendarOptions = {
    timeZone: 'local', // This will be updated once studio timezone is loaded
    plugins: [momentPlugin, momentTimezonePlugin, resourceTimeGridPlugin],
    firstDay: 0,
    schedulerLicenseKey: 'CC-Attribution-NonCommercial-NoDerivatives',
    initialView: 'resourceTimeGridDay',
    height: "auto",
    refetchResourcesOnNavigate: true,
    allDaySlot: false,
    // Don't allow events to overlap.
    slotEventOverlap: false,
    droppable: true,
    editable: true,
    // Set to true to handle events spanning midnight properly
    nextDayThreshold: '00:00:00',
    // Force sticky headers for page scrolling
    stickyHeaderDates: true,

    events: this.getCalendarEvents(),
    resources: ((fetchInfo, successCallback, failureCallback) => {
      const baseLoader = this.getCalendarResources();
      baseLoader(fetchInfo, (data) => {
        const filtered = Array.isArray(data) && this.selectedInstructorId
          ? data.filter(resource => resource.id === this.selectedInstructorId)
          : data;

        if ((!filtered || filtered.length === 0) && Array.isArray(data) && data.length) {
          const fallback = data[0];
          this.selectedInstructorId = fallback.id;
          this.persistSelectedInstructor();
          this.updateCurrentInstructorName();
          successCallback([fallback]);
          return;
        }

        successCallback(filtered);
      }, failureCallback);
    }),

    loading: (isLoading) => {
      if (isLoading) {
      } else {
        // Hide custom popover if mouse hover exits.
        $("#custom-popover").hover(null, function () {
          $(this).hide();
        });
        // Hide custom context menu if mouse hover exits.
        $("#custom-context-menu").hover(null, function () {
          $(this).hide();
        });

        // Mount the instructor toggle component in the header toolbar
        this.mountInstructorToggleInHeader();

        // Apply initial resource filtering after calendar loads
        setTimeout(() => {
          this.applyResourceFiltering();
        }, 100);
      }
    },

    eventDrop: (info: any) => {
      let eventID = info?.oldEvent?._def?.extendedProps?.entityId;
      let eventType = info?.event?._def?.extendedProps?.appointmentType;
      // Use studio timezone for consistent time handling
      let newStartTime = this.studioTimezone
        ? moment.tz(info.event.start, this.studioTimezone).format('YYYY-MM-DDTHH:mm:ss')
        : moment(info.event.start).format('YYYY-MM-DDTHH:mm:ss');
      let newInstructor = info?.newResource?._resource?.id;
      // field_status is the attendee-resolved status; a group lesson with mixed
      // attendee statuses has none, so also lock when any attendee is charged.
      let isPosted = info?.event?._def?.extendedProps?.['eventDetails']?.data?.field_status == '59'
        || !!info?.event?._def?.extendedProps?.['groupHasPosted'];
      // hideAll() to hide all tippy instances.
      hideAll({ duration: this.tippyHideDuration });
      this.noTippy = true;

      // Set dragging flag to prevent periodic refreshes
      this.isDragging = true;

      // If the event is posted, revert the move and show message
      if (isPosted) {
        info.revert();
        this.showSnackbar('Posted events cannot be moved.');
        this.isDragging = false;
        return;
      }

      let patchData = {
        'field_date_and_time': newStartTime,
      };

      if (eventType === 'schedules') {
        patchData['field_schedule_instructor'] = newInstructor;
      } else if (eventType === 'services') {
        patchData['field_executive'] = newInstructor;
      } else {
        patchData['field_instructor'] = newInstructor;
      }

      this._entityRESTService.patchEntity('events', eventType, eventID, patchData).subscribe({
        next: () => {
          // A successful PATCH is authoritative here. The API response shape does not
          // reliably echo the updated datetime in a format suitable for client-side
          // equality checks, so trust the 2xx response and let the calendar refresh.
        },
        error: (error) => {
          // Handle any errors from the API
          info.revert(); // Revert on error
          this.showSnackbar('An error occurred while updating.');
        },
        complete: () => {
          this.noTippy = false;
          this.isDragging = false; // Reset dragging flag
          this.refreshCalendar(); // Refresh to show the new position
        }
      });
    },

    // Change in duration
    eventResize: (eventResizeInfo: any) => {
      let eventID = eventResizeInfo?.oldEvent?._def?.extendedProps?.entityId;
      let eventType = eventResizeInfo?.event?._def?.extendedProps?.appointmentType;

      // hideAll() to hide all tippy instances.
      hideAll({ duration: this.tippyHideDuration });
      this.noTippy = true;

      // Set dragging flag to prevent periodic refreshes
      this.isDragging = true;

      this._entityRESTService.patchEntity('events', eventType, eventID, {
        'field_duration': this.calcDuration(eventResizeInfo.event.start, eventResizeInfo.event.end),
      }).subscribe((data) => {
        this.noTippy = false;
        this.isDragging = false; // Reset dragging flag
        this.refreshCalendar();
      });
    },

    eventContent: (arg: any) => {
      // Confirmation status for events.
      let isConfirmed = arg.event._def.extendedProps?.['eventDetails']?.data?.isConfirmed;
      let lessonType = arg.event._def.extendedProps?.['appointmentType'];

      // This is where the meat of content comes through.
      let contentToShow = document.createElement('div');
      contentToShow.innerHTML = arg.event._def.extendedProps['dataToShow'];

      // Add confirmation status.
      let confirmationStatus = document.createElement('div');
      confirmationStatus.className = "confirmation-status";

      // Only show confirmations for regular lessons.
      if (isConfirmed && lessonType == 'lesson') {
        confirmationStatus.innerHTML = '<span class="material-icons">check_box</span>';
      } else if (isConfirmed == false && lessonType == 'lesson') {
        confirmationStatus.innerHTML = '<span class="material-icons">check_box_outline_blank</span>';
      }

      // Makes confirmation clickable.
      confirmationStatus.addEventListener("click", (e: Event) => {
        e.stopPropagation();
        this.toggleEventConfirmation(arg);
      })

      // Notes icon
      let notesIcon = document.createElement('div');
      notesIcon.className = "notes-icon";
      notesIcon.innerHTML = '<span class="material-icons">notes</span>';

      // Check if the event has notes
      let hasNotes = arg.event._def.extendedProps?.['eventDetails']?.data?.field_notes || arg.event._def.extendedProps?.['eventDetails']?.data?.field_reason_for_canceling;
      if (!hasNotes) {
        notesIcon.style.display = 'none';
      }

      notesIcon.addEventListener("click", (e: Event) => {
        e.stopPropagation();
      });

      // Payment reminder icon
      let paymentIcon = document.createElement('div');
      paymentIcon.className = "payment-icon";

      // Only show payment reminder for lessons and when payment is needed
      if (lessonType === 'lesson' && arg.event._def.extendedProps?.['eventDetails']?.data?.field_calendar_payment_reminder) {
        paymentIcon.innerHTML = '<span class="material-icons" style="color: #FFD700; text-shadow: 0 0 2px black;">attach_money</span>';
      } else {
        paymentIcon.style.display = 'none';
      }

      let arrayOfDomNodes = [confirmationStatus, contentToShow, notesIcon, paymentIcon];

      return { domNodes: arrayOfDomNodes }
    },

    eventDidMount: (info) => {
      // Custom context menu.
      let eventId = info.event.id

      // Cleanup any existing tooltip for this event to prevent duplicates
      if (this.tippyEventHoverInstances.has(eventId)) {
        const existingInstance = this.tippyEventHoverInstances.get(eventId);
        if (existingInstance) {
          existingInstance.destroy();
        }
        this.tippyEventHoverInstances.delete(eventId);
      }

      info.el.addEventListener("contextmenu", (jsEvent) => {
        let bundle = info.event._def?.extendedProps?.['appointmentType'];
        if (bundle == 'lesson' /*|| bundle == 'group_lesson'*/ || bundle == 'services' || bundle == 'schedules') {
          jsEvent.preventDefault();
          this.copyData = info.event?._def?.extendedProps?.['eventDetails']?.data;

          // Custom popup box for when selecting times in the calendar.
          var left = jsEvent.pageX;
          var top = jsEvent.pageY;
          var theHeight = $("#custom-context-menu").height();
          $("#custom-context-menu").show();
          $("#custom-context-menu").css(
            "left",
            left - $("#custom-context-menu").width() / 2 + "px"
          );
          $("#custom-context-menu").css(
            "top",
            top - theHeight / 2 + 20 + "px"
          );
          $("#custom-context-menu").css("display", "block");
        }
      });

      // Get event data for tooltip content
      const eventData = info.event._def?.extendedProps?.['eventDetails']?.data;
      const tooltipBaseContent = info.event.extendedProps?.['tooltip'] || '';

      // Only create tooltip if there's content or the event has next events capability
      if (tooltipBaseContent || (eventData?.has_next_events)) {
        // Structure the tooltip content with clearly separated sections
        let tooltipContent = '<div class="tooltip-base-content">' + tooltipBaseContent + '</div>';

        // Add next events placeholder if this event has next events capability
        if (eventData?.has_next_events) {
          tooltipContent += '<div id="next-events-content" class="next-events-loading">Loading upcoming appointments...</div>';
        }

        // Add small delay to ensure element is properly positioned in DOM
        setTimeout(() => {
          // Double-check element still exists and is attached to DOM
          if (!info.el || !info.el.parentNode) {
            LoggerService.warn(`[TOOLTIP] Element no longer exists for event ${eventId}, skipping tooltip creation`);
            return;
          }

          try {
            // Create the tooltip
            const tippyInstance = tippy(info.el, {
              allowHTML: true,
              placement: "bottom",
              arrow: roundArrow,
              animation: 'fade',
              theme: 'light',
              duration: [500, 0],
              content: tooltipContent,
              // Improve positioning
              popperOptions: {
                modifiers: [
                  {
                    name: 'preventOverflow',
                    options: {
                      boundary: 'viewport',
                    },
                  },
                  {
                    name: 'flip',
                    options: {
                      fallbackPlacements: ['top', 'left', 'right'],
                    },
                  },
                ],
              },
              onShow: (instance) => {
                // Only fetch next events if this event has that capability
                if (eventData?.has_next_events) {
                  // Create a normalized cache key based on the event ID and date
                  const cacheKey = this.createNextEventsCacheKey(eventData.id, eventData.event_date);
                  LoggerService.log(`[HOVER] Tooltip onShow for event ${eventData.id}, checking cache for key ${cacheKey}`);
                  LoggerService.log(`[HOVER] Original event date: ${eventData.event_date}`);

                  // Check if data is already in cache
                  if (this.nextEventsCache.has(cacheKey)) {
                    LoggerService.log(`[HOVER] Using cached next events data for tooltip id=${eventData.id}`);
                    const cachedData = this.nextEventsCache.get(cacheKey);

                    // Get the original tooltip content without the next events section
                    const baseContent = '<div class="tooltip-base-content">' + tooltipBaseContent + '</div>';

                    // Format and add the cached content
                    const nextEventsHtml = this.formatNextEventsHtml(cachedData);
                    instance.setContent(baseContent + nextEventsHtml);
                    return;
                  }

                  // Update loading message
                  const loadingEl = document.getElementById('next-events-content');
                  if (loadingEl) {
                    loadingEl.innerHTML = '<div class="loading-spinner">Loading...</div>';
                  }

                  LoggerService.log(`[HOVER] Fetching next events for tooltip id=${eventData.id}`);
                  // Use our centralized method to load next events
                  this.loadNextEvents(
                    eventData.id,
                    eventData.event_date,
                    eventData.student_account_id || null,
                    (data: any) => {
                      LoggerService.log(`[HOVER] Received next events for tooltip id=${eventData.id}`);
                      // Get the original tooltip content without the next events section
                      const baseContent = '<div class="tooltip-base-content">' + tooltipBaseContent + '</div>';
                      // Format the next events HTML
                      const nextEventsHtml = this.formatNextEventsHtml(data);
                      // Set combined content
                      instance.setContent(baseContent + nextEventsHtml);
                    },
                    (error: any) => {
                      LoggerService.error(`[HOVER] Error fetching next events for tooltip id=${eventData.id}:`, error);
                      // Update with error message, keeping the base content
                      const baseContent = '<div class="tooltip-base-content">' + tooltipBaseContent + '</div>';
                      instance.setContent(baseContent +
                        '<div class="next-events-container"><p>Error loading upcoming appointments</p></div>');
                    }
                  );
                }
              },
              onDestroy: () => {
                // Clean up from our tracking when destroyed
                this.tippyEventHoverInstances.delete(eventId);
              }
            });

            // Store the instance for cleanup later
            if (tippyInstance) {
              this.tippyEventHoverInstances.set(eventId, tippyInstance);
            }
          } catch (error) {
            LoggerService.error(`[TOOLTIP] Error creating tooltip for event ${eventId}:`, error);
          }
        }, 10); // Small delay to ensure DOM stability
      }
    },

    customButtons: {
      goBackAWeek: {
        text: '<<',
        hint: 'Go back a week',
        click: () => {
          let calendarApi = this.calendarComponent.getApi();
          calendarApi.incrementDate({ weeks: -1 }); // Moves the calendar one week back
        }
      },
      goForwardWeek: {
        text: '>>',
        hint: 'Go forward a week',
        click: () => {
          let calendarApi = this.calendarComponent.getApi();
          calendarApi.incrementDate({ weeks: 1 }); // Moves the calendar one week forward
        }
      },
      instructorToggle: {
        text: '',
        hint: 'Filter Instructors',
        click: () => {
          // This will be handled by the Angular component
        }
      },
      studioTime: {
        text: '', // Will be updated dynamically
        hint: 'Studio Time',
        click: () => {
          // No action on click
        }
      }
    },

    headerToolbar: false,

    titleFormat: (date) => {
      let newTitleFormat = moment(date.end.marker).format('dddd[,] MMMM DD[, ]YYYY[ - Week #]');

      // Use WeekCalculationService for correct week number (handles Week 53 logic)
      const weekNum = this.weekCalculationService.getWeekNumber(date.end.marker.toISOString());
      newTitleFormat += weekNum;

      // The weekNumber number
      this.weekNumber = weekNum.toString();

      return (newTitleFormat).toString();
    },

    eventClick: (info) => {
      // Tapping an event should dismiss the empty-slot booking popover.
      this.hideCustomPopover();

      // Check if we have an event with a student
      if (info.event?._def?.extendedProps?.['studentDetails']?.['studentAccountId']) {
        const studentId = info.event._def.extendedProps['studentDetails']['studentAccountId'];
        const currentDate = info.event.start;
        const currentEventId = info.event._def.extendedProps?.['entityId'];

        // Log raw date information to diagnose format issues
        LoggerService.log(`[CLICK] Raw event date: ${currentDate.toISOString()}`);

        // Create a normalized cache key using our helper method
        const cacheKey = this.createNextEventsCacheKey(currentEventId, currentDate.toISOString());

        LoggerService.log(`[CLICK] Event click for event ${currentEventId}, checking cache for key ${cacheKey}`);

        // Check if data is already in cache from tooltip hover
        if (this.nextEventsCache.has(cacheKey)) {
          LoggerService.log(`[CLICK] Using cached next events data for dialog from tooltip cache id=${currentEventId}`);
          const cachedData = this.nextEventsCache.get(cacheKey);

          // Create a copy of the info object with next events data included in extendedProps
          const enhancedInfo = {
            ...info,
            event: {
              ...info.event,
              _def: {
                ...info.event._def,
                extendedProps: {
                  ...info.event._def.extendedProps,
                  // Add upcomingEventList property using cached data
                  upcomingEventList: (cachedData && cachedData.upcomingEventList) || []
                }
              }
            }
          };

          // Open the dialog with enhanced data from cache
          this.openDialog(AppointmentDetailsComponent, "defaultWithData", enhancedInfo);
        } else {
          // If not in cache, fetch the data as before
          LoggerService.log(`[CLICK] No cache found, fetching next events for dialog id=${currentEventId}`);
          this.loadNextEvents(
            currentEventId,
            currentDate.toISOString(),
            studentId,
            (data: any) => {
              LoggerService.log(`[CLICK] Received next events for dialog id=${currentEventId}`);
              // Store in cache for potential future use
              this.nextEventsCache.set(cacheKey, data);

              // Create a copy of the info object with next events data included in extendedProps
              const enhancedInfo = {
                ...info,
                event: {
                  ...info.event,
                  _def: {
                    ...info.event._def,
                    extendedProps: {
                      ...info.event._def.extendedProps,
                      // Add upcomingEventList property without modifying the original object
                      upcomingEventList: (data && data.upcomingEventList) || []
                    }
                  }
                }
              };

              // Open the dialog with enhanced data
              this.openDialog(AppointmentDetailsComponent, "defaultWithData", enhancedInfo);
            },
            (error: any) => {
              LoggerService.error(`[CLICK] Error fetching next events data for id=${currentEventId}:`, error);

              // Even on error, provide the upcomingEventList as an empty array
              const enhancedInfo = {
                ...info,
                event: {
                  ...info.event,
                  _def: {
                    ...info.event._def,
                    extendedProps: {
                      ...info.event._def.extendedProps,
                      upcomingEventList: []
                    }
                  }
                }
              };

              // Open the dialog with the current event data plus empty upcomingEventList
              this.openDialog(AppointmentDetailsComponent, "defaultWithData", enhancedInfo);
            }
          );
        }
      } else {
        // If there's no student ID, create a copy with an empty upcomingEventList
        const enhancedInfo = {
          ...info,
          event: {
            ...info.event,
            _def: {
              ...info.event._def,
              extendedProps: {
                ...(info.event?._def?.extendedProps || {}),
                upcomingEventList: []
              }
            }
          }
        };

        // Open the dialog with the current event data
        this.openDialog(AppointmentDetailsComponent, "defaultWithData", enhancedInfo);
      }

      // hideAll() to hide all tippy instances.
      hideAll({ duration: this.tippyHideDuration });
    },

    eventMouseLeave: function (mouseLeaveInfo) {
      // hideAll() to hide all tippy instances.
      hideAll({ duration: this.tippyHideDuration });
    },

    selectable: true,
    // Lower long-press threshold so a brief touch-and-hold initiates a drag-select
    // for picking a custom duration. The single-tap path below covers the common case.
    selectLongPressDelay: 250,
    longPressDelay: 250,

    select: (info) => {
      // Use the shared helper so the popover is positioned within the viewport on touch.
      this.showBookingPopover(info.jsEvent);

      // Get the current starting time.
      // info.start is already in the studio timezone from FullCalendar
      // We need to format it without converting to local time
      if (this.studioTimezone) {
        // Use moment-timezone to format in the studio timezone
        this.currentSelectedStartTime = moment.tz(info.start, this.studioTimezone).format('YYYY-MM-DD[T]HH:mm:ss');
      } else {
        // Fallback if studio timezone not loaded yet
        this.currentSelectedStartTime = moment(info.start).format('YYYY-MM-DD[T]HH:mm:ss');
      }

      // Calculate duration of selected area.
      this.currentSelectedDuration = this.calcDuration(info.start, info.end);

      // Grab the instructor ID, to be used to pass into the form.
      this.currentSelectedInstructorID = info.resource.id;
    },

    // When the events over loped it set false the selectable of calendar
    selectOverlap: function (event) {
      return false;
    },

    selectAllow: (date) => {
      // Find the time diff for checking the druation.
      var fromTime = date.start.getTime() / 1000;
      var toTime = date.end.getTime() / 1000;
      var timeDiff = (toTime - fromTime) / 3600; // will give difference in hrs


      var theHeight = $("#selected-hours").height();
      $("#selected-hours").css({
        "z-index": "9999",
        position: "absolute",
        display: "block",
      });

      return true;
    },

    // A single tap on a slot opens the booking popover with a default 45-min duration.
    // Touch users no longer need to hold-and-drag just to book.
    dateClick: (info) => {
      info.jsEvent.preventDefault();
      if (info.jsEvent.button === 2) {
        return;
      }
      if (!this._permissionsService.canAccess('lessons_edit')) {
        return;
      }

      const slotStart = info.date;
      const defaultDurationMinutes = 45;
      const slotEnd = new Date(slotStart.getTime() + defaultDurationMinutes * 60000);

      if (this.studioTimezone) {
        this.currentSelectedStartTime = moment.tz(slotStart, this.studioTimezone).format('YYYY-MM-DD[T]HH:mm:ss');
      } else {
        this.currentSelectedStartTime = moment(slotStart).format('YYYY-MM-DD[T]HH:mm:ss');
      }
      this.currentSelectedDuration = this.calcDuration(slotStart, slotEnd);
      this.currentSelectedInstructorID = info.resource?.id;

      this.showBookingPopover(info.jsEvent);
    },

    resourceLabelDidMount: (mountArg) => {
      // Hover for the instructors.
      let tippyInstance = tippy(mountArg.el, {
        allowHTML: true,
        placement: "bottom",
        arrow: roundArrow,
        animation: 'fade',
        duration: [500, 0],
        theme: 'light',
        content: mountArg.resource?.extendedProps?.['info'],
      })

      this.tippyInstructorHoverInstances.set(mountArg.resource.id, tippyInstance);
    },

    // resourceLabelWillUnmount: function (unmountArg) {
    //   // Get the Tippy instance associated with the element
    //   const tippyInstance = tippy.getInstance(unmountArg.el);

    //   // If there is a Tippy instance, destroy it
    //   if (tippyInstance) {
    //     tippyInstance.destroy();
    //   }
    // },

    // Default configuration.
    slotDuration: "00:15:00",
    slotLabelInterval: "00:01:00",
    displayEventTime: false,
    slotLabelFormat: {
      hour: 'numeric',
      minute: '2-digit',
      omitZeroMinute: false,
      meridiem: 'short'
    },
  };

  updateCalendarEvents(params: any) {
    LoggerService.log('[TIMEZONE] updateCalendarEvents called with params:', params);
    LoggerService.log('[TIMEZONE] filterDateRaw:', params?.filterDateRaw);
    LoggerService.log('[TIMEZONE] filterDate:', params?.filterDate);
    LoggerService.log('[TIMEZONE] Current studio timezone:', this.studioTimezone);

    // Since FullCalendar is set to studio timezone, pass the YYYY-MM-DD string directly.
    if (params.filterDateRaw) {
      LoggerService.log('[TIMEZONE] Navigating to date:', params.filterDateRaw);
      this.calendarComponent.getApi().gotoDate(params.filterDateRaw);
    }
    this.calendarOptions.events = this.getCalendarEvents(params);
    this.calendarOptions.resources = this.getCalendarResources(params);
  }

  getCalendarEvents(params: any = null, updateColorsOnly?) {
    return (fetchInfo, successCallback, failureCallback) => {
      LoggerService.log('[TIMEZONE] getCalendarEvents called');
      LoggerService.log('[TIMEZONE] Studio timezone loaded:', this.studioTimezoneLoaded);
      LoggerService.log('[TIMEZONE] Current studio timezone:', this.studioTimezone);

      // CRITICAL: Wait for studio timezone to load before fetching events.
      // Otherwise the initial fetch runs in the browser timezone and returns the wrong day.
      if (!this.studioTimezoneLoaded) {
        LoggerService.log('[TIMEZONE] Waiting for studio timezone to load, returning empty events');
        successCallback([]);
        return;
      }

      LoggerService.log('[TIMEZONE] fetchInfo:', fetchInfo);
      LoggerService.log('[TIMEZONE] fetchInfo.startStr:', fetchInfo.startStr);
      LoggerService.log('[TIMEZONE] fetchInfo.endStr:', fetchInfo.endStr);
      LoggerService.log('[TIMEZONE] fetchInfo.start:', fetchInfo.start);

      // Don't call getAMTSessionTime here - it needs filterDate to be set first

      let endpoint = "/api/dayview/calendar/events?";

      // Extract the date from fetchInfo.startStr/endStr. These are already in studio timezone
      // because the calendar's timeZone option was set before render.
      const startDateOnly = fetchInfo.startStr.split('T')[0]; // e.g., "2025-11-01"
      const endDateOnly = fetchInfo.endStr.split('T')[0];     // e.g., "2025-11-02"

      // CRITICAL: API expects naive times (no timezone) and treats them as studio local.
      // Sending .toISOString() converts to UTC, which shifts the day for any non-UTC studio.
      this.newDateStart = startDateOnly + 'T00:00:00';
      this.newDateEnd = endDateOnly + 'T00:00:00';
      this.calendarDateInquiry = startDateOnly + 'T12:00:00';

      LoggerService.log('[TIMEZONE] newDateStart (naive):', this.newDateStart);
      LoggerService.log('[TIMEZONE] newDateEnd (naive):', this.newDateEnd);
      LoggerService.log('[TIMEZONE] calendarDateInquiry (naive):', this.calendarDateInquiry);

      if (params) {

        if (params.filterDate) {
          LoggerService.log('[TIMEZONE] Processing filterDate in getCalendarEvents');
          LoggerService.log('[TIMEZONE] params.filterDateRaw:', params.filterDateRaw);
          // Naive date for the API, same rationale as newDateStart above.
          const dateForAPI = params.filterDateRaw
            ? params.filterDateRaw + 'T12:00:00'
            : this.newDateStart;
          LoggerService.log('[TIMEZONE] dateForAPI for backend (naive):', dateForAPI);
          endpoint = endpoint + "&calendar_date=" + dateForAPI;
        }

        if (params.filterStudent) {
          endpoint = endpoint + "&student=" + params.filterStudent;
        }

        if (params.filterLessonType) {
          endpoint = endpoint + "&lessonType=" + params.filterLessonType;
        }

        if (params.filterInstructorCategory) {
          endpoint = endpoint + "&instructor_category=" + params.filterInstructorCategory;

          // this.getCalendarResources(params);
        }

        if (params.filterGroupLesson) {
          endpoint = endpoint + "&group_lesson=" + params.filterGroupLesson;
        }

        if (params.filterLesson) {
          endpoint = endpoint + "&lesson=" + params.filterLesson;
        }

        if (params.filterServices) {
          endpoint = endpoint + "&services=" + params.filterServices;
        }

        if (params.filterHiddenEvents) {
          endpoint = endpoint + "&hidden_events=" + params.filterHiddenEvents;
        }

      }

      // Send start && end times.
      endpoint = endpoint + "&start=" + this.newDateStart;
      endpoint = endpoint + "&end=" + this.newDateEnd;

      // Run change on next browser MicroTask.
      Promise.resolve().then(() => {
        LoggerService.log('[TIMEZONE] Setting filterDate for UI');
        LoggerService.log('[TIMEZONE] newDateStart (naive):', this.newDateStart);

        // Parse the naive date (e.g. "2025-11-02T00:00:00"). This represents the
        // studio's local date, so build the Date in the browser's local time to
        // preserve the Y-M-D components for the date picker.
        const dateParts = this.newDateStart.split('T')[0].split('-');
        const year = parseInt(dateParts[0]);
        const month = parseInt(dateParts[1]) - 1;
        const day = parseInt(dateParts[2]);
        this.filterDate = new Date(year, month, day);
        LoggerService.log('[TIMEZONE] filterDate set to:', this.filterDate);

        // Now that filterDate is set, process session times
        this.getAMTSessionTime();
      })

      if (updateColorsOnly) {
        this.Events = this.fixEventColors(data);
        successCallback(data);
        return;
      }

      this._drupalRESTService.httpGET(endpoint).subscribe(data => {
        const events = data as any[]; // Cast data to an array
        if (!events || events.length === 0) {
          successCallback([]);
        } else {
          this.Events = this.fixEventColors(events);
          successCallback(events);
        }
      }, error => {
        LoggerService.error('Error fetching calendar events:', error);
        successCallback([]);
      });
    }
  }

  fixEventColors(data) {
    // LoggerService.log('Events: ', data);

    // Check if colors should change.
    for (const key in data) {
      let event = data[key];

      // Fix for events crossing day boundary (end time appears before start time)
      if (moment(event.end).isBefore(moment(event.start))) {
        // Adjust the end time to be on the next day
        let correctedEnd = moment(event.end).add(1, 'days').format();
        LoggerService.log(`Correcting event ${event.id} end time: ${event.end} -> ${correctedEnd}`);
        data[key].end = correctedEnd;
      }

      // Handle past events coloring
      if (moment(data[key].end) < moment()) {
        // LoggerService.log('event', event);
        if (event?.appointmentType == 'lesson' && event?.status != 'Showed' && event?.status !== 'Cancelled' && event?.status !== 'Rescheduled' && event?.status !== 'No Showed Not Charged') {
          // data[key].color = "#FF4136";
        }
        // // Schedules
        // if (event?.appointmentType == 'schedules' && event?.status != 'Showed' && event?.status !== 'Cancelled' && event?.status !== 'Rescheduled' && event?.status !== 'No Showed Not Charged') {
        //   data[key].color = "#474747";
        // }
        // // Services
        // if (event?.appointmentType == 'services' && event?.status != 'Showed' && event?.status !== 'Cancelled' && event?.status !== 'Rescheduled' && event?.status !== 'No Showed Not Charged') {
        //   data[key].color = "#888888";
        // }
      }

      // If event is No Show, Charged
      if (event?.status == 'No Showed, Charged') {
        data[key].color = "#626267";
      }

      // Make sure Pending Status events are displayed correctly
      if (event?.status == 'Pending Status') {
        // Ensure color is properly set for better visibility if needed
        // data[key].color = "#F2473F";
      }

      // Client-derived color wins over the server-supplied event.color.
      // Remove this line to fall back to the server-computed color.
      data[key].color = this._eventColorService.getEventColor(data[key]);
    }
    return data;
  }

  handleEventDidMount(info: any) {
    // LoggerService.log(info.event.extendedProps);
    // eventDidMount
  }

  getCalendarResources(thisParams: any = null) {
    let endpoint = "/api/dayview/calendar/resources?";

    return (fetchInfo, successCallback, failureCallback) => {
      // Check if we have the calendar API and configuration
      this.updateSlotTimesForDate(fetchInfo.startStr);

      // Extract date-only and interpret in studio timezone for consistent week calculation
      const dateOnly = fetchInfo.startStr.split('T')[0];
      // Create a date string at noon in studio timezone to avoid any day boundary issues
      const dateForWeekCalc = moment.tz(dateOnly + ' 12:00', this.studioTimezone).toISOString();

      let params = [
        { parameter: 'start', value: fetchInfo.startStr },
        { parameter: 'end', value: fetchInfo.endStr },
        // Using custom week calculation to handle Week 53 logic correctly
        { parameter: 'week', value: this.weekCalculationService.getWeekNumber(dateForWeekCalc) },
        // Using custom year calculation to handle year boundary cases correctly
        // Standard moment().isoWeekYear() doesn't work because our weeks start on Sunday
        // while ISO weeks start on Monday, causing issues at year boundaries
        { parameter: 'year', value: this.weekCalculationService.getCorrectYearForWeek(dateForWeekCalc) },
      ];

      if (thisParams?.filterInstructorCategory) {
        params = [
          ...params,
          { parameter: 'instructor_category', value: thisParams.filterInstructorCategory },
        ];
      }

      this._drupalRESTService.httpGET(endpoint, params)
        .subscribe(data => {
          this.calcSummary(data);

          // Store all resources for filtering
          if (Array.isArray(data)) {
            this.allResources = [...data];
            this.resourcesArray = data.map(resource => ({
              id: resource.id,
              title: resource.title
            }));
            this.instructors = [...this.resourcesArray];

            if (!this.selectedInstructorId && data.length) {
              const stored = this.selectedInstructorId;
              const fallback = stored ? data.find(r => r.id === stored) : null;
              if (fallback) {
                this.selectedInstructorId = fallback.id;
              } else {
                this.selectedInstructorId = data[0].id;
              }
              this.persistSelectedInstructor();
              this.updateCurrentInstructorName();
            }

            const filteredData = this.selectedInstructorId
              ? data.filter(resource => resource.id === this.selectedInstructorId)
              : data;

            this.currentlyVisibleResources = new Set(filteredData.map(resource => resource.id));
            successCallback(filteredData);
          } else {
            successCallback(data);
          }

          this.tippyInstructorHoverInstances.forEach((tippyInstance, resourceId) => {
            if (this.calendarComponent && this.calendarComponent.getApi()) {
              const resource = this.calendarComponent.getApi().getResourceById(resourceId);
              if (resource) {
                tippyInstance.setContent(resource.extendedProps['info']);
              }
            }
          });
        },
          error => this.handleError(error)
        );
    };
  }

  private updateSlotTimesForDate(startStr: string): void {
    if (!this.calendarComponent?.getApi() || !this.AMTCalendarConfiguration?.['office_hours']) {
      return;
    }

    let dayOfWeek: string;
    if (this.studioTimezone) {
      const dateOnly = startStr.split('T')[0];
      dayOfWeek = moment.tz(dateOnly, this.studioTimezone).format('dddd');
    } else {
      dayOfWeek = moment(startStr).format('dddd');
    }

    this.applyOfficeHoursForDay(dayOfWeek);
  }

  /**
   * Fits the time grid to the studio's hours for the displayed day. A closed
   * day (no hours stored) uses the widest open range instead of keeping the
   * previous day's.
   */
  private applyOfficeHoursForDay(dayName: string): void {
    const officeHours = this.AMTCalendarConfiguration?.['office_hours'];
    if (!officeHours?.minTime) {
      // No working hours configured: leave the range alone.
      return;
    }
    const dayHours = officeHours[dayName];

    const api = this.calendarComponent?.getApi();
    const start = dayHours?.start || officeHours.minTime;
    const end = dayHours?.end || officeHours.maxTime;
    if (api && (api.getOption('slotMinTime') !== start || api.getOption('slotMaxTime') !== end)) {
      api.setOption('slotMinTime', start);
      api.setOption('slotMaxTime', end);
    }
  }

  /** Weekday name of the date on screen, in the studio's timezone. */
  private displayedDayName(): string {
    const date = this.calendarComponent?.getApi()?.getDate() ?? new Date();
    return this.studioTimezone ? moment.tz(date, this.studioTimezone).format('dddd') : moment(date).format('dddd');
  }

  calcSummary(data) {
    LoggerService.log("calcSummary called...", data)
    let alreadyCounted: number[] = [];

    // Reset Summary
    this.summaryCount = {
      privateLessonDaily: 0,
      privateLessonWeekly: 0,
      privateTakenLessonDaily: 0,
      privateTakenLessonWeekly: 0,
    }

    data.forEach((element: { id: string; privateLesson: number[]; privatePostedLesson: number[]; }) => {
      let id = parseInt(element.id)

      if (alreadyCounted.includes(id)) { } else {
        this.summaryCount.privateLessonWeekly += element.privateLesson[1];
        this.summaryCount.privateLessonDaily += element.privateLesson[0];
        this.summaryCount.privateTakenLessonWeekly += element.privatePostedLesson[1];
        this.summaryCount.privateTakenLessonDaily += element.privatePostedLesson[0];

        alreadyCounted.push(id);
      };
    });
  }

  // Get the session time.
  getAMTSessionTime(forceRefresh: boolean = false) {
    // Only fetch if we don't already have the data or if force refresh is requested
    if (this.AMTSessionTime && !forceRefresh) {
      // Data already loaded, just process it
      this.processAMTSessionTime();
      return;
    }

    let endpoint = "/api/dayview/calendar/configurations-session";
    this._drupalRESTService.httpGET(endpoint)
      .subscribe(data => {
        this.AMTSessionTime = data;
        this.processAMTSessionTime();
      });
  }

  // Clear cached session time data (useful when configuration might have changed)
  clearSessionTimeCache() {
    this.AMTSessionTime = null;
  }

  // Load configuration sessions from Drupal.
  processAMTSessionTime() {
    let dataObject = this.AMTSessionTime;

    // Only process session times if we have both filterDate and studioTimezone
    if (!this.filterDate || !this.studioTimezone) {
      LoggerService.log('[SESSION] Cannot process session times - missing required data');
      LoggerService.log('[SESSION] filterDate:', this.filterDate);
      LoggerService.log('[SESSION] studioTimezone:', this.studioTimezone);
      return;
    }

    // Calculate the day name from the date being displayed
    // Use the date string directly to avoid timezone conversion issues
    const dateStr = moment(this.filterDate).format('YYYY-MM-DD');
    const dayName = moment(dateStr).format('dddd').toLowerCase();
    LoggerService.log('[SESSION] Calculated day name:', dayName, 'from date:', dateStr);

    // Strip the gray colors - clear ALL time slot elements to prevent residue
    // Clear both slot lanes and individual time slots
    $('.fc-timegrid-slot-lane').css(
      "background",
      ""  // Use empty string instead of "none" to allow CSS to take over
    );
    // Also clear all time slots with data-time attributes to remove any previous day's gray backgrounds
    $('.fc-timegrid-slot').css(
      "background",
      ""
    );

    // Check if the day exists in dataObject and apply styles
    if (dataObject[dayName]) {
      dataObject[dayName].forEach(function (item) {
        // Target time slots more specifically
        $('.fc-timegrid-slot[data-time="' + item + '"]').css(
          "background",
          "#ccc"
        );
      });
    }

    // Log session time processing for debugging
    LoggerService.log('[SESSION] Processing session times for day:', dayName);
    LoggerService.log('[SESSION] Using filterDate:', this.filterDate);
    LoggerService.log('[SESSION] filterDate as date:', this.filterDate ? moment(this.filterDate).format('YYYY-MM-DD dddd') : 'not set');
    LoggerService.log('[SESSION] Studio timezone:', this.studioTimezone);
    LoggerService.log('[SESSION] newDateStart:', this.newDateStart);
    if (dataObject[dayName]) {
      LoggerService.log('[SESSION] Applying gray times for', dayName + ':', dataObject[dayName]);
    } else {
      LoggerService.log('[SESSION] No gray times configured for', dayName);
    }
  }

  getAMTCalendarConfiguration() {
    let endpoint = "/api/dayview/calendar/settings";

    this._drupalRESTService.httpGET(endpoint)
      .subscribe({
        next: (data) => {
          this.AMTCalendarConfiguration = data;

          // Office hours for the day on screen (widest open range when closed)
          const currentDay = this.displayedDayName();
          const daySpecificHours = this.AMTCalendarConfiguration['office_hours'][currentDay];

          LoggerService.log('[TIMEZONE] Initial calendar configuration:');
          LoggerService.log('[TIMEZONE] Current day for initial config:', currentDay);
          LoggerService.log('[TIMEZONE] Day-specific hours:', daySpecificHours);
          LoggerService.log('[TIMEZONE] Default office hours:', data['office_hours']);

          const slotMinTime = daySpecificHours?.start || data['office_hours']['minTime'];
          const slotMaxTime = daySpecificHours?.end || data['office_hours']['maxTime'];

          this.calendarOptions = {
            ...this.calendarOptions,
            slotDuration: data['duration'],
            nowIndicator: true,
            slotLabelInterval: data['slot_interval'] || data['duration'],
            displayEventTime: data['event_time'],
            resourceOrder: 'order_id',
            slotMinTime,
            slotMaxTime,
            // Shades closed days; open days fill the grid, so they show no shading.
            businessHours: buildOfficeBusinessHours(data['office_hours'])
          };

          LoggerService.log('[TIMEZONE] Initial slotMinTime:', slotMinTime);
          LoggerService.log('[TIMEZONE] Initial slotMaxTime:', slotMaxTime);

          this.applyOfficeHoursForDay(currentDay);

        },
        error: (error) => {
          LoggerService.error('Error loading calendar configuration:', error);
          // Handle error appropriately
        }
      });
  }

  getAMTFilterConfiguration() {
    let endpoint = "/api/dayview/calendar/filterInit";

    this._drupalRESTService.httpGET(endpoint)
      .subscribe(data => {
        this.filterLessonType = data['lessonTypes'];

        this.filterInstructorCategory = data['teacherCategory'];
      });
  }

  getInstructorList() {
    let endpoint = "/api_rest/v1/teacherList";

    this._drupalRESTService.httpGET(endpoint)
      .subscribe(data => {
        this.InstructorList = data;
      })
  }

  getAMTAutocomplete() {
    let endpoint = "/api_rest/v1/autocomplete?";

    this._drupalRESTService.httpGET(endpoint)
      .subscribe(data => {
        this.AMTConfiguration = data;
      });
  }

  getAMTDayView() {
    let endpoint = "/api/dayview/resource?instructor_category=78&instructor=&lessonType=&student=&calendar_date=&start=2021-12-01T00%3A00%3A00&end=2021-12-02T00%3A00%3A00&_=1638394993251";

    this._drupalRESTService.httpGET(endpoint)
      .subscribe(data => {
        this.AMTDayView = data;
      });
  }

  override handleError(error: any) {
    // LoggerService.log("error", error);


    // Handle authentication errors.
    if (error.status == 302) {
      // this.errorMessage = error.error.message;
      // LoggerService.log('this means user logged in')
    }

    // Handle authentication errors.
    if (error.status == 403 || error.status == 400) {

      // TODO: this should save state

      // User needs to login.
      this._authService.set_user_authenticated(false);
      this._router.navigate(['/auth/login'], { queryParams: { logged_out_inactive: true } })
    }
  }

  calcDuration(dateStart: moment.MomentInput, dateEnd: moment.MomentInput) {
    let startDate = moment(dateStart);
    let endDate = moment(dateEnd);
    let duration = moment.duration(endDate.diff(startDate));

    let MINUTES = duration.asMinutes();
    let m = duration.asMinutes() % 60;
    let h = (MINUTES - m) / 60;
    let HHMM = (h < 10 ? "0" : "") + h.toString() + ":" + (m < 10 ? "0" : "") + m.toString();

    return HHMM
  }

  toggleEventConfirmation(event) {
    LoggerService.log('event', event);

    // Confirmation status for events.
    let isConfirmed = event.event._def.extendedProps?.['eventDetails']?.data?.isConfirmed;
    let eventID = event.event._def.extendedProps?.['entityId'];

    // Update the data in the event object
    event.event._def.extendedProps['eventDetails'].data.isConfirmed = !isConfirmed;

    // Force FullCalendar to re-render this specific event immediately
    if (this.calendarComponent?.getApi()) {
      const fcEvent = this.calendarComponent.getApi().getEventById(event.event.id);
      if (fcEvent) {
        // Use setExtendedProp to update specific extended prop
        fcEvent.setExtendedProp('eventDetails', { ...event.event._def.extendedProps.eventDetails });
        // Set a special flag to force a full rerender
        fcEvent.setExtendedProp('_forceRerender', Date.now());
      }
    }

    let body = {
      field_is_confirmed: !isConfirmed,
    }

    this._entityRESTService.patchEntity('events', 'lesson', eventID, body).subscribe({
      next: (data) => {
        // Show snackbar message based on new confirmation status
        if (!isConfirmed) {
          this.showSnackbar('Thank you for confirming this lesson.');
        } else {
          this.showSnackbar('Lesson confirmation has been removed.');
        }
      },
      error: (error) => {
        // In case of error, revert the UI change
        LoggerService.error('Error updating confirmation status:', error);

        // Revert the data change
        event.event._def.extendedProps['eventDetails'].data.isConfirmed = isConfirmed;

        // Force a re-render again to show the reverted state
        if (this.calendarComponent?.getApi()) {
          const fcEvent = this.calendarComponent.getApi().getEventById(event.event.id);
          if (fcEvent) {
            fcEvent.setExtendedProp('eventDetails', { ...event.event._def.extendedProps.eventDetails });
            fcEvent.setExtendedProp('_forceRerender', Date.now());
          }
        }

        this.showSnackbar('Failed to update confirmation status. Please try again.');
      }
    });
  }

  isEventHidden(): boolean {
    return this.copyData?.['field_exclude_from_display'] == 1;
  }

  hideClick() {
    this.toggleEventVisibility(true);
  }

  unhideClick() {
    this.toggleEventVisibility(false);
  }

  toggleEventVisibility(hide: boolean) {
    $("#custom-context-menu").hide();

    const bundle = this.copyData?.['bundle'];
    const entityType = 'events';
    const eventId = this.copyData?.['id'];

    if (!bundle || !eventId) {
      LoggerService.error('No event selected or missing bundle/id');
      return;
    }

    const patchData = {
      field_exclude_from_display: [{ value: hide }]
    };

    this._entityRESTService.patchEntity(entityType, bundle, eventId, patchData)
      .subscribe(
        response => {
          LoggerService.log(`Event ${hide ? 'hidden' : 'unhidden'} successfully`, response);
          this.refreshCalendar();
        },
        error => {
          LoggerService.error(`Error ${hide ? 'hiding' : 'unhiding'} event`, error);
          if (this._snackBar) {
            this._snackBar.open(`Failed to ${hide ? 'hide' : 'unhide'} event. Please try again.`, 'Close', {
              duration: 3000,
            });
          }
        }
      );
  }

  copyClick() {
    $("#custom-context-menu").hide();

    const bundle = this.copyData?.['bundle'];
    const entityType = 'events';
    let componentType: ComponentType<unknown>;
    let fieldsData: any = {};
    const ensureArray = (value: any) => Array.isArray(value) ? value : (value ? [value] : []);

    this._entityRESTService.getEntity(entityType, bundle, this.copyData?.['id']).subscribe(data => {
      switch (bundle) {
        case 'lesson':
          componentType = EventLessonEntityComponent;
          fieldsData = {
            'field_type': data?.['field_type'],
            'field_instructor': data?.['field_instructor']?.['id'],
            'field_duration': this.copyData?.['eventDuration'],
            'field_date_and_time': data?.['field_date_and_time'],
            'field_student': [{
              'type': 'attendees',
              'bundle': 'attendance',
              'title': data?.['field_student']?.['title'],
              'field_description': data?.['field_student']?.['field_description'],
              'field_enrollment': data?.['field_student']?.['field_enrollment'],
              'field_status': '64', // Pending status
              'field_students': data?.['field_student']?.['field_students'],
              'field_student_account': (data?.['field_student']?.['title'] + ' (' + data?.['field_student']?.['field_student_account'] + ')'),
            }]
          };
          break;
        case 'services':
          componentType = EventServicesEntityComponent;
          fieldsData = {
            'field_type': data?.['field_type'],
            'field_executive': data?.['field_executive']?.['id'],
            'field_duration': this.copyData?.['eventDuration'],
            'field_date_and_time': data?.['field_date_and_time'],
            'field_notes': data?.['field_notes'],
            'field_student': [{
              'type': 'attendees',
              'bundle': 'attendance',
              'field_student_account': data?.['field_student']?.['field_student_account']
                ? `${data?.['field_student']?.['title']} (${data?.['field_student']?.['field_student_account']})`
                : undefined,
              'field_students': data?.['field_student']?.['field_students'],
            }]
          };
          break;
        case 'group_lesson':
          componentType = EventGroupLessonEntityComponent;
          fieldsData = {
            'field_type': data?.['field_type'],
            'field_instructor': ensureArray(data?.['field_instructor']?.['id']),
            'field_duration': this.copyData?.['eventDuration'],
            'field_date_and_time': data?.['field_date_and_time'],
            'field_students': ensureArray(data?.['field_students']).map(student => this.prepareStudentData(student))
          };
          break;
        case 'schedules':
          componentType = EventSchedulesEntityComponent;
          fieldsData = {
            'field_type': data?.['field_type'],
            'field_duration': this.copyData?.['eventDuration'],
            'field_date_and_time': data?.['field_date_and_time'],
            'field_schedule_instructor': [data?.['field_schedule_instructor']?.['id']],
          };
          break;
        default:
          LoggerService.error('Unsupported bundle type:', bundle);
          return;
      }

      this._dialogService.openDialog(componentType, "defaultWithData", {
        data: {
          EntityID: null,
          eckType: entityType,
          bundle: bundle,
          action: 'create',
          fieldsData: fieldsData,
        },
      }).afterClosed().subscribe(data => {
        this.refreshCalendar();
      });
    });
  }

  private prepareStudentData(studentData: any): any {
    if (!studentData) return null;

    return {
      'type': 'attendees',
      'bundle': 'attendance',
      'title': studentData?.['title'],
      'field_description': studentData?.['field_description'],
      'field_enrollment': studentData?.['field_enrollment'],
      'field_status': '64', // Pending status
      'field_students': studentData?.['field_students'],
      'field_student_account': `${studentData?.['title']} (${studentData?.['field_student_account']})`,
    };
  }

  pasteClick() {
    LoggerService.log('paste click');
  }

  closeContextMenu() {
    $("#custom-context-menu").hide();
  }

  hideCustomPopover() {
    if (this.customPopover?.nativeElement) {
      this.customPopover.nativeElement.style.display = 'none';
    } else {
      $("#custom-popover").hide();
    }
    this.detachPopoverDismissListener();
  }

  // "Coaching" booking options (tap-to-book popover + New Event menu): one
  // entry per studio Coaching package. Same as the desktop day view.
  coachingPackages: { id: string, name: string }[] = [];
  coachingPackagesLoading = false;
  bookingMenuOpenKey = 0;

  /** Booking menu option picked for the clicked slot. */
  onBookingMenuChoice(choice: BookingMenuChoice): void {
    const slot = {
      'field_duration': this.currentSelectedDuration,
      'field_date_and_time': this.currentSelectedStartTime,
    };
    switch (choice) {
      case 'lesson':
        this.openEntityComponent(EventLessonEntityComponent, 'events', 'lessons', 'create', '', { 'field_instructor': this.currentSelectedInstructorID, ...slot });
        break;
      case 'service':
        this.openEntityComponent(EventServicesEntityComponent, 'events', 'services', 'create', '', { 'field_executive': this.currentSelectedInstructorID, ...slot });
        break;
      case 'schedule':
        this.openEntityComponent(EventSchedulesEntityComponent, 'events', 'schedules', 'create', '', { 'field_schedule_instructor': [this.currentSelectedInstructorID], ...slot });
        break;
      case 'group_lesson':
        this.openEntityComponent(EventGroupLessonEntityComponent, 'events', 'group_lesson', 'create', '', { 'field_instructor': [this.currentSelectedInstructorID], ...slot });
        break;
      case 'inquiry':
        this.addInquiryFromSlot();
        break;
    }
    this.hideCustomPopover();
  }

  loadCoachingPackages(): void {
    this.coachingPackagesLoading = this.coachingPackages.length === 0;
    this._packagesService.getCoachingPackages().subscribe(packages => {
      this.coachingPackages = packages;
      this.coachingPackagesLoading = false;
    });
  }

  openCoachingLesson(coachingPackage: { id: string, name: string }, fromSlot: boolean): void {
    const fieldsData: any = {
      'field_type': '1411',
      '__coaching_package': coachingPackage,
    };
    if (fromSlot) {
      fieldsData['field_instructor'] = this.currentSelectedInstructorID;
      fieldsData['field_duration'] = this.currentSelectedDuration;
      fieldsData['field_date_and_time'] = this.currentSelectedStartTime;
    }
    this.openEntityComponent(EventLessonEntityComponent, 'events', 'lessons', 'create', '', fieldsData);
  }

  private popoverDismissListener: ((ev: PointerEvent) => void) | null = null;

  private attachPopoverDismissListener(): void {
    this.detachPopoverDismissListener();
    // Defer attachment so the same tap that opened the popover doesn't immediately close it.
    setTimeout(() => {
      const handler = (ev: PointerEvent) => {
        const popover = document.getElementById('custom-popover');
        if (!popover) return;
        if (ev.target instanceof Node && popover.contains(ev.target)) {
          return;
        }
        this.hideCustomPopover();
      };
      this.popoverDismissListener = handler;
      document.addEventListener('pointerdown', handler, true);
    }, 0);
  }

  private detachPopoverDismissListener(): void {
    if (this.popoverDismissListener) {
      document.removeEventListener('pointerdown', this.popoverDismissListener, true);
      this.popoverDismissListener = null;
    }
  }

  /**
   * Position and show the booking popover near the tapped/selected slot.
   * Used by both the touch tap path (dateClick) and the drag-select path (select).
   */
  private showBookingPopover(jsEvent: MouseEvent | TouchEvent | any): void {
    const popover = $("#custom-popover");
    if (!popover.length) {
      return;
    }

    // Resolve coordinates from mouse, touch, or pointer events.
    let pageX: number = jsEvent?.pageX;
    let pageY: number = jsEvent?.pageY;
    if ((pageX === undefined || pageY === undefined) && jsEvent?.changedTouches?.length) {
      pageX = jsEvent.changedTouches[0].pageX;
      pageY = jsEvent.changedTouches[0].pageY;
    }
    if ((pageX === undefined || pageY === undefined) && jsEvent?.touches?.length) {
      pageX = jsEvent.touches[0].pageX;
      pageY = jsEvent.touches[0].pageY;
    }

    // Show first so we can read its size.
    popover.css("display", "block").show();
    const popoverWidth = popover.outerWidth() || 0;
    const popoverHeight = popover.outerHeight() || 0;

    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const scrollX = window.scrollX || window.pageXOffset || 0;
    const scrollY = window.scrollY || window.pageYOffset || 0;

    // Default: center horizontally over the tap point, drop below it.
    let left = (pageX ?? scrollX + viewportWidth / 2) - popoverWidth / 2;
    let top = (pageY ?? scrollY + viewportHeight / 2) + 10;

    // Clamp within the viewport so it never falls off-screen on a phone.
    const minLeft = scrollX + 8;
    const maxLeft = scrollX + viewportWidth - popoverWidth - 8;
    if (left < minLeft) left = minLeft;
    if (left > maxLeft) left = Math.max(minLeft, maxLeft);

    const minTop = scrollY + 8;
    const maxTop = scrollY + viewportHeight - popoverHeight - 8;
    // If the popover would clip below, place it above the tap instead.
    if (top > maxTop && pageY !== undefined) {
      top = pageY - popoverHeight - 10;
    }
    if (top < minTop) top = minTop;

    popover.css({ left: left + "px", top: top + "px" });
    this.attachPopoverDismissListener();
    this.bookingMenuOpenKey++;
    this.loadCoachingPackages();
  }

  navigateForward(): void {
    const api = this.calendarComponent?.getApi();
    if (api) {
      api.next();
      this.currentDate = api.getDate();
    }
  }

  navigateBackward(): void {
    const api = this.calendarComponent?.getApi();
    if (api) {
      api.prev();
      this.currentDate = api.getDate();
    }
  }
}
